/* tslint:disable */
/* eslint-disable */

/**
 * 0 = FullDay
 * 
 * 1 = AM
 * 
 * 2 = PM
 */
export enum HalfDayType {
  FullDay = 0,
  AM = 1,
  PM = 2
}
